export default __webpack_public_path__ + "static/media/new.3b40060c.png";